import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GRUPOS_EXISTENTES = [
  'adm', 'contabil', 'rh', 'bpo', 'fiscal',
  'deskbee', 'ernedu', 'inovadados', 'machado', 'proesc',
];

const FORM_INICIAL = {
  username: '',
  email: '',
  password: '',
  name: '',
  grupo: '',
  id_bpo: '0',
  id_bpo_consolida: '',
};

const CadastrarUsuario = () => {
  const [form, setForm] = useState(FORM_INICIAL);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [grupoNovo, setGrupoNovo] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [tentativas, setTentativas] = useState([]);
  const [carregandoBloqueios, setCarregandoBloqueios] = useState(true);

  const authHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('access')}` },
  });

  const carregarUsuarios = useCallback(async () => {
    setCarregando(true);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/usuarios/listar/`,
        authHeader()
      );
      setUsuarios(resp.data.usuarios || []);
    } catch (e) {
      toast.error('Erro ao carregar usuários.');
    } finally {
      setCarregando(false);
    }
  }, []);

  const carregarBloqueios = useCallback(async () => {
    setCarregandoBloqueios(true);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/usuarios/bloqueados/`,
        authHeader()
      );
      setTentativas(resp.data.tentativas || []);
    } catch (e) {
      toast.error('Erro ao carregar logins bloqueados.');
    } finally {
      setCarregandoBloqueios(false);
    }
  }, []);

  useEffect(() => {
    carregarUsuarios();
    carregarBloqueios();
  }, [carregarUsuarios, carregarBloqueios]);

  const handleDesbloquear = async (username) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/usuarios/desbloquear/`,
        { username },
        authHeader()
      );
      toast.success(`Login de "${username}" desbloqueado.`);
      carregarBloqueios();
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao desbloquear login.';
      toast.error(msg);
    }
  };

  const handleChange = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleGrupoSelect = (valor) => {
    if (valor === '__novo__') {
      setGrupoNovo(true);
      handleChange('grupo', '');
    } else {
      setGrupoNovo(false);
      handleChange('grupo', valor);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/usuarios/criar/`,
        form,
        authHeader()
      );
      toast.success('Usuário criado com sucesso!');
      setForm(FORM_INICIAL);
      setGrupoNovo(false);
      carregarUsuarios();
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao criar usuário.';
      toast.error(msg);
    } finally {
      setEnviando(false);
    }
  };

  const handleDelete = async (u) => {
    const ok = window.confirm(
      `Excluir definitivamente o operador "${u.name || u.username}" (ID ${u.id})?\n\nEsta ação é irreversível e remove também o histórico de acessos.`
    );
    if (!ok) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/usuarios/${u.id}/deletar/`,
        authHeader()
      );
      toast.success('Operador excluído.');
      carregarUsuarios();
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao excluir operador.';
      toast.error(msg);
    }
  };

  return (
    <div className="container-fluid py-4">

      <div className="card mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0" style={{ color: '#212529' }}>
            <i className="fas fa-user-plus me-2" style={{ color: '#212529' }}></i>
            Cadastrar Usuário
          </h5>
          <small style={{ color: '#6c757d' }}>
            Cria um novo acesso na plataforma
          </small>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-username">Usuário (login)</label>
                <input
                  type="text"
                  id="cadastro-username"
                  className="form-control"
                  value={form.username}
                  onChange={(e) => handleChange('username', e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-name">Nome (exibição no app)</label>
                <input
                  type="text"
                  id="cadastro-name"
                  className="form-control"
                  value={form.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-email">Email</label>
                <input
                  type="email"
                  id="cadastro-email"
                  className="form-control"
                  value={form.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-password">Senha</label>
                <div className="input-group">
                  <input
                    type={mostrarSenha ? 'text' : 'password'}
                    id="cadastro-password"
                    className="form-control"
                    value={form.password}
                    onChange={(e) => handleChange('password', e.target.value)}
                    autoComplete="new-password"
                    minLength={6}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                    onClick={() => setMostrarSenha((v) => !v)}
                  >
                    <i className={mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                  </button>
                </div>
                <small style={{ color: '#6c757d' }}>Mínimo 6 caracteres</small>
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-grupo">Grupo</label>
                {!grupoNovo ? (
                  <select
                    id="cadastro-grupo"
                    className="form-select"
                    value={form.grupo}
                    onChange={(e) => handleGrupoSelect(e.target.value)}
                    required
                  >
                    <option value="">Selecione...</option>
                    {GRUPOS_EXISTENTES.map((g) => (
                      <option key={g} value={g}>{g}</option>
                    ))}
                    <option value="__novo__">Novo grupo…</option>
                  </select>
                ) : (
                  <div className="input-group">
                    <input
                      type="text"
                      id="cadastro-grupo"
                      className="form-control"
                      placeholder="Digite o novo grupo"
                      value={form.grupo}
                      onChange={(e) => handleChange('grupo', e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => { setGrupoNovo(false); handleChange('grupo', ''); }}
                    >
                      ↩
                    </button>
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-id-bpo">id_bpo (0 = interno)</label>
                <input
                  type="number"
                  id="cadastro-id-bpo"
                  className="form-control"
                  value={form.id_bpo}
                  onChange={(e) => handleChange('id_bpo', e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label" htmlFor="cadastro-id-bpo-consolida">
                  Consolida com (id de outro cliente)
                </label>
                <input
                  type="number"
                  id="cadastro-id-bpo-consolida"
                  className="form-control"
                  placeholder="vazio = nenhum"
                  value={form.id_bpo_consolida}
                  disabled={String(form.id_bpo).trim() === '0' || form.id_bpo === ''}
                  onChange={(e) => handleChange('id_bpo_consolida', e.target.value)}
                />
                <div className="form-text">
                  Só para usuário de cliente: permite somar os dados desse outro cliente no botão
                  &quot;Consolidar empresas&quot; (ex.: usuário do 27 → 25). Fora da consolidação o acesso continua bloqueado.
                </div>
              </div>
            </div>
            <div className="mt-3">
              <button type="submit" className="btn btn-dark" disabled={enviando}>
                {enviando ? 'Salvando...' : 'Cadastrar usuário'}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0" style={{ color: '#212529' }}>
            <i className="fas fa-user-lock me-2" style={{ color: '#212529' }}></i>
            Logins bloqueados
          </h5>
          <small style={{ color: '#6c757d' }}>
            Contas bloqueadas após 3 tentativas de senha incorreta
          </small>
        </div>
        <div className="card-body">
          {carregandoBloqueios ? (
            <p style={{ color: '#6c757d' }}>
              <i className="fas fa-spinner fa-spin me-2"></i>Carregando...
            </p>
          ) : tentativas.length === 0 ? (
            <p className="mb-0" style={{ color: '#6c757d' }}>
              <i className="fas fa-check-circle me-2"></i>
              Nenhum login bloqueado ou com tentativas de senha errada.
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle">
                <thead>
                  <tr>
                    <th>Usuário</th>
                    <th>IP</th>
                    <th>Falhas</th>
                    <th>Última tentativa</th>
                    <th>Situação</th>
                    <th className="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {tentativas.map((t) => (
                    <tr key={`${t.username}-${t.ip_address}`}>
                      <td>{t.username}</td>
                      <td>{t.ip_address}</td>
                      <td>{t.falhas}</td>
                      <td>
                        {t.ultima_tentativa
                          ? new Date(t.ultima_tentativa).toLocaleString('pt-BR')
                          : '-'}
                      </td>
                      <td>
                        {t.bloqueado ? (
                          <span className="badge bg-danger">Bloqueado</span>
                        ) : (
                          <span className="badge bg-warning text-dark">
                            {t.falhas}/3 falhas
                          </span>
                        )}
                      </td>
                      <td className="text-end">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-dark"
                          title="Desbloquear e zerar tentativas"
                          onClick={() => handleDesbloquear(t.username)}
                        >
                          <i className="fas fa-unlock me-1"></i>
                          Desbloquear
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-header bg-white">
          <h5 className="mb-0" style={{ color: '#212529' }}>
            <i className="fas fa-users me-2" style={{ color: '#212529' }}></i>
            Usuários cadastrados
          </h5>
        </div>
        <div className="card-body">
          {carregando ? (
            <p style={{ color: '#6c757d' }}>
              <i className="fas fa-spinner fa-spin me-2"></i>Carregando...
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Usuário</th>
                    <th>Email</th>
                    <th>Grupo</th>
                    <th>id_bpo</th>
                    <th>Consolida com</th>
                    <th className="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((u) => (
                    <tr key={u.id}>
                      <td>{u.id}</td>
                      <td>{u.name}</td>
                      <td>{u.username}</td>
                      <td>{u.email}</td>
                      <td><span className="badge bg-dark">{u.grupo}</span></td>
                      <td>{u.id_bpo}</td>
                      <td>{u.id_bpo_consolida ?? '—'}</td>
                      <td className="text-end">
                        {u.id !== 2 && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-dark"
                            title="Excluir operador"
                            onClick={() => handleDelete(u)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CadastrarUsuario;
